import {BaseContainerModel} from "../../base-container.model";
import { bl_wf_md_process_transition_notification_subscriber_RowClass, bl_wf_md_process_transition_notification_subscriber_RowInterface} from "../../../dbschema";

export class WfMdTransitionSubscriberContainerModel extends BaseContainerModel{
  bl_wf_md_process_transition_notification_subscriber: bl_wf_md_process_transition_notification_subscriber_RowInterface = new bl_wf_md_process_transition_notification_subscriber_RowClass();
}
